import React from 'react';
import { Link } from 'react-router-dom';
import './App.css';
// import TermsOfService from './TermsOfService';

const Footer = () => {
  return (
    <footer className="footer">
      <Link to="/terms" className="form-link">Terms of Service</Link>
      <span className="footer-divider"> | </span>
      <Link to="/privacy" className="form-link">Privacy Policy</Link>
    </footer>
  );
};

export default Footer;